import React from "react";
import Sidebar from "../common/Sidebar";
// import Overview from "./pages/Overview";
import { Outlet } from "react-router-dom";
import Header from "../common/Header";

const User = () => {
    return (
        <>
            <div className="user d-flex">
                <Sidebar />
                <div className="main-content">
                    <Header />
                    {/* <Overview /> */}
                    <Outlet />
                </div>
            </div>
        </>
    )
}

export default User;